module.exports = __webpack_public_path__ + "img/google-plus-square.d0e27cdf.svg";